import { Component, inject } from '@angular/core';
import {
  AbstractListComponent,
  createSimpleColumn,
  openSingleControlDialog,
  whitespaceValidator,
} from '@cappus/shared-common';

import {
  type TableColumnConfig,
  TableComponent,
  type TableSettingsConfig,
} from '@pct-ng/feature-table-material';
import { MatCard } from '@angular/material/card';
import { ForbiddenNicknameListFilterPanelComponent } from './forbidden-nickname-list-filter-panel.component';
import { Validators } from '@angular/forms';
import { isNil } from 'ngx-editor/utils';
import { MatDialog } from '@angular/material/dialog';
import { openSuccessToast } from '@pct-ng/feature-message-material';
import { ForbiddenNicknameDtoService } from '../../../core/dto/forbidden-nickname/forbidden-nickname-dto.service';
import type { ForbiddenNicknameFiltersToBackend } from '../../../core/dto/forbidden-nickname/forbidden-nickname-filter';
import type { ForbiddenNicknameGetDTO } from '@cappus/sdk-mecap-backend';

@Component({
  selector: 'mecap-forbidden-nickname-list',
  imports: [MatCard, TableComponent, ForbiddenNicknameListFilterPanelComponent],
  providers: [ForbiddenNicknameDtoService],
  templateUrl: './forbidden-nickname-list.component.html',
})
export class ForbiddenNicknameListComponent extends AbstractListComponent<
  ForbiddenNicknameGetDTO,
  ForbiddenNicknameFiltersToBackend,
  ForbiddenNicknameDtoService
> {
  protected override readonly showRowActionEdit = false;
  protected readonly tableId = 'forbidden-nickname-list-table';
  protected readonly i18nParentPrefix = 'PAGES.FORBIDDEN_NICKNAME';
  protected readonly i18nPrefix = `${this.i18nParentPrefix}.LIST`;
  protected readonly detailsI18nPrefix = `${this.i18nParentPrefix}.DETAILS`;
  protected readonly service = inject(ForbiddenNicknameDtoService);
  readonly #matDialog = inject(MatDialog);
  protected readonly rowActions = this.createRowActions();

  constructor() {
    super();
  }
  protected buildColumnConfig(): TableColumnConfig<ForbiddenNicknameGetDTO>[] {
    const i18nPrefix = `${this.i18nPrefix}.COLUMN.`;
    return [createSimpleColumn('value', 'value', `${i18nPrefix}VALUE`, true)];
  }

  protected override buildTableSettings(): TableSettingsConfig {
    return {
      mustShowColumns: ['value'],
    };
  }

  protected clickOnNew(): void {
    openSingleControlDialog(
      {
        onSubmit: value => this.service.create({ value }),
        validators: [Validators.required, Validators.maxLength(50), whitespaceValidator()],
        inputLabelText: `${this.detailsI18nPrefix}.LABEL`,
        title: `${this.detailsI18nPrefix}.TITLE`,
        errorCodes: 'TAKEN_FORBIDDEN_NICKNAME_VALUE',
        overrideErrors: {
          TAKEN_FORBIDDEN_NICKNAME_VALUE: `${this.i18nParentPrefix}.DETAILS.TAKEN_FORBIDDEN_NICKNAME_VALUE`,
        },
      },
      this.#matDialog,
    )
      .afterClosed()
      .subscribe(value => {
        if (isNil(value)) {
          return;
        }
        this.dataSource.reload();
        openSuccessToast({ message: `${this.i18nParentPrefix}.CREATED_NEW_SUCCESSFULLY` });
      });
  }
}
